import {
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core'
import { AiContentFeedbackModalComponent } from 'src/app/Components/ai-content-feedback-modal/ai-content-feedback-modal.component'
import { DetectionLimitExhaustModalComponent } from '../../detection-limit-exhaust-modal/detection-limit-exhaust-modal.component'
import { NoopScrollStrategy } from '@angular/cdk/overlay'
import { MatDialog } from '@angular/material/dialog';
import { WebsiteService } from 'src/app/_services/website.service';
declare const fpPromise: any;

@Component({
  selector: 'app-aicontent-detector-tool',
  templateUrl: './aicontent-detector-tool.component.html',
  styleUrls: ['./aicontent-detector-tool.component.scss']
})
export class AIContentDetectorToolComponent implements OnInit {
  Math = Math;
  isConfidentialMode = false;
  inputWordCount: number = 0
  inputText: string = ''
  showWordLimitErr: boolean = false
  wordLimitErrHeading: string = ''
  wordLimitErrMsg: string = ''
  usersCurrentAvailableSessionCount: number = -1
  isSubmitBtnDisabled: boolean = false
  isAIContent: boolean = false
  aiContentScore: number = 0
  humanContentScore: number = 0
  showLoadingState: boolean = false
  showErrorModal: boolean = false
  setUserId: string = null
  contentDetectorLimit: number = 500
  aboveLimitText: string = ''
  isLimitExhausted: boolean = false;
  formSection: boolean = true;
  thankSection: boolean = false;
  country: string;
  apiResponse: any = undefined;
  aiContentId: string = "";
  isSubmitting: boolean = false;

  constructor (
    private _dialog: MatDialog,
    private _appService: WebsiteService,
    private renderer: Renderer2
  ) {
  }

  ngOnInit(): void {
    this.generateAndSetUserId();
    if(this.setUserId) this.getUserSessionCount();
    this._attachKeydownEventListener(document.getElementById('inputEditor'))
    this.attachPasteEventListener(document.getElementById('inputEditor'))
  }

  onInputEditorChange (txt: string) {
    this._updateCounts(txt)
    this.resetScoreAndInputText()
    if (this.inputWordCount <= 500 && this.isSubmitBtnDisabled) {
      this.isSubmitBtnDisabled = false
    }
  }

  private _wordCount (text) {
    return text.split(/(\s+)/).filter(x => x.trim().length > 0).length
  }

  _updateCounts (txt: string) {
    this.inputText = txt
    this.inputWordCount = this._wordCount(txt.trim())
  }

  openFeedbackModal (likeFlag: boolean): void {
    try {
      const dialogRef = this._dialog.open(AiContentFeedbackModalComponent, {
        width: '500px',
        height: 'auto',
        disableClose: true,
        backdropClass: 'custom-dialog-background',
        panelClass: "border-radius16",
        data: {
          isLiked: likeFlag,
          inputText: this.inputText,
          userID: this.setUserId,
          apiResponse: this.apiResponse,
          aiContentId: this.aiContentId
        },
        scrollStrategy: new NoopScrollStrategy()
      })

      dialogRef.afterClosed().subscribe(result => {
      })
    } catch (e) {
      console.log('Err is: ', e)
    }
  }

  clearEditors (): void {
    this.inputWordCount = 0
    document.getElementById('inputEditor').innerHTML = ''
    this.resetScoreAndInputText()
  }

  sendTextForAIDetection() {
    this.generateAndSetUserId();
    if (this.inputWordCount < 100) {
      this.showWordLimitErr = true
      this.wordLimitErrMsg = ''
      this.wordLimitErrHeading = 'Please write minimum 100 words'
    } else if (this.inputWordCount > 500) {
      //for 500 words limit count
      this.isSubmitBtnDisabled = true
      this.showWordLimitErr = true
      this.wordLimitErrHeading = 'Word limit reached'
      this.wordLimitErrMsg =
        'You can enter <b>500 words</b> at a time. Please shorten the paragraph and retry.'
      // setTimeout(() => {
      //   this.showWordLimitErr = false
      // }, 3000)
    } else if (this.usersCurrentAvailableSessionCount === 0) {
      this.showWordLimitErr = false
      this._dialog.open(DetectionLimitExhaustModalComponent, {
        backdropClass: 'custom-dialog-background',
        width: '490px',
        height: 'auto',
        scrollStrategy: new NoopScrollStrategy(),
        panelClass: "border-radius16",
      })
    } else if (this.showErrorModal) {
      this.clearEditors()
    } else {
      this.showWordLimitErr = false
      this.showLoadingState = true
      //API logic and session count will be deducted here
      let requestBody = {
        text: this.inputText
      }
      this._appService
        .aiDetectionRequest(requestBody, this.setUserId)
        .subscribe({
          complete: () => {},
          next: (response: any) => {
            this.apiResponse = response?.body?.result[0];
            this.showLoadingState = false;
            this.isAIContent = response?.body?.result[0]?.fake
            this.aiContentScore = response?.body?.result[0].ai_score;
            this.humanContentScore = response?.body?.result[0].human_score;
            // this.humanContentScore = this.isAIContent
            //   ? 0
            //   : response?.body?.result[0].human_score
            // this.aiContentScore = this.isAIContent
            //   ? response?.body?.result[0].ai_score
            //   : 0
            this.aiContentId = response?.body?.aiContentId;
            this.getUserSessionCount()
            document
              .querySelector('#inputEditor')
              .childNodes.forEach((ele: HTMLElement) => {
                setTimeout(() => {
                  if (this.isAIContent) {
                    ele.style.backgroundColor = '#DC262626'
                    ele.style.color = '#DC2626'
                    ele.style.display = 'inline'
                    ele.style.fontWeight = '600'
                    ele.style.lineHeight = '26px'
                  }
                }, 500)
              })
          },
          error: error => {
            console.log('Error is: ', error);
            this.showLoadingState = false
            if (error?.status === 400 || error?.error?.error === 'Rate limit exceeded for today. Try again tomorrow.') {
              this.showWordLimitErr = false;
              this._dialog.open(DetectionLimitExhaustModalComponent, {
                backdropClass: 'custom-dialog-background',
                width: '490px',
                height: 'auto',
                scrollStrategy: new NoopScrollStrategy(),
                panelClass: "border-radius16",
              });
              this.usersCurrentAvailableSessionCount = 0;
            }
            else {
              this.showErrorModal = true;
              this.wordLimitErrMsg = '';
            }
          }
        })
    }
  }

  hideLimitError () {
    this.showWordLimitErr = false
  }

  resetScoreAndInputText () {
    this.isAIContent = false
    this.showErrorModal = false
    this.showLoadingState = false
    this.showWordLimitErr = false
    this.aiContentScore = 0
    this.humanContentScore = 0
  }

  private _attachKeydownEventListener (element: HTMLElement) {
    element.onfocus = (e: any) => {
      if (!element.children.length) {
        let newParagraph = document.createElement('p')
        newParagraph.innerHTML = '<br />'
        element.appendChild(newParagraph)
        window.getSelection().collapse(newParagraph, 0)
        e.preventDefault()
      }

      //TODO: To be added only if we want to disable Trinka's extension on the AI Detector's text-editor
      // if(document.querySelector('trinka-extension') && (document.querySelector('trinka-extension') as HTMLElement).style.display !== 'none') (document.querySelector('trinka-extension') as HTMLElement).style.display = 'none';
    }
    element.onblur = (e: any) => {
      if (!element.textContent) {
        element.innerHTML = ''
      }
      e.preventDefault()
    }
  }

  async generateAndSetUserId() {
    const today = new Date();
    const dateKey = `${today.getDate()}${today.getMonth() + 1}${today.getFullYear()}`
    this.setUserId = localStorage.getItem(dateKey)
    if (!this.setUserId) {
      const fingerprintJSResponse = (await (await fpPromise).get());
      this.setUserId = fingerprintJSResponse.visitorId;
      localStorage.setItem(dateKey, this.setUserId);
      this.getUserSessionCount();
    }
  }


  attachPasteEventListener(element: HTMLElement) {
    element.addEventListener('paste', ($event: any) => {
      $event.preventDefault()
      let text = $event.clipboardData.getData('text/plain');
      text = text.replace(/\n{2,}/g, '\n');
      document.execCommand('insertText', false, text);
    });
  }
  getUserSessionCount() {
    if (this.setUserId) {
      this._appService.getAIDetectionSessionCount(this.setUserId).subscribe({
        next: (response: any) => {
          this.usersCurrentAvailableSessionCount = response?.count;
        },
        complete: () => { },
        error: (err: any) => {
          this.usersCurrentAvailableSessionCount = 0;
        }
      })
    } 
    else this.usersCurrentAvailableSessionCount = 10;
  }

  @ViewChild('inputEditor') inputEditor: ElementRef;
  activeExample = '';

  exampleTexts = {
    ai: `Artificial intelligence has fundamentally transformed the landscape of modern research. By leveraging advanced algorithms, researchers can now analyze vast datasets with unprecedented efficiency, uncovering patterns that would previously have remained hidden. Furthermore, these tools facilitate collaboration across disciplines, fostering innovation and accelerating discovery. In fields ranging from healthcare to climate science, machine learning models are enabling scientists to generate hypotheses, test assumptions, and validate findings at a remarkable pace. Moreover, natural language processing has streamlined the literature review process, allowing researchers to synthesize thousands of publications in a fraction of the time once required. However, the integration of artificial intelligence into research also presents significant challenges. Concerns regarding data privacy, algorithmic bias, and the reproducibility of results must be carefully addressed to ensure the integrity of scientific inquiry. Additionally, researchers must develop a nuanced understanding of these technologies in order to interpret their outputs responsibly. Institutions play a pivotal role in this regard, as they are responsible for establishing clear guidelines and providing adequate training. Ultimately, the successful adoption of artificial intelligence in research will depend on striking a careful balance between innovation and accountability. By embracing these tools thoughtfully, the academic community can unlock new possibilities while upholding the core values of rigor, transparency, and ethical responsibility that define meaningful research.`,
    humanized: `AI has really changed how research gets done these days. With smart algorithms, researchers can go through huge datasets much faster than before, and they often spot patterns nobody would have noticed otherwise. On top of that, these tools help people from different fields work together, which sparks new ideas and speeds things up. Whether it’s healthcare or climate science, machine learning is helping scientists come up with ideas, test them, and check their results a lot quicker. Language tools have also made literature reviews way easier, so you can get through thousands of papers in a fraction of the time it used to take. That said, bringing AI into research isn’t all smooth sailing. There are real worries about data privacy, biased algorithms, and whether results can actually be reproduced, and those need to be handled carefully if we want research to stay trustworthy. Researchers also need to properly understand how these tools work so they can read the outputs the right way. Universities have a big part to play here, since they’re the ones who need to set clear rules and offer decent training. In the end, getting AI right in research comes down to finding the balance between trying new things and staying accountable. If we use these tools wisely, academia can open up new possibilities without giving up on being careful, open, and ethical.`,
    human: `I should say at the outset that the archive was not what I expected. The district collectorate records for 1952 to 1958, which earlier work (Menon 2004; Raghavan 2011) treats as complete, turned out to have a gap of almost fourteen months, from March 1955 to May 1956. The clerk who showed me the shelves thought the files had gone to Madras during reorganisation and never come back. He may be right. I spent two afternoons in the state archives looking for them and found one bundle, water-damaged, that seems to cover part of 1955, though the dates on several letters are illegible. What survives is still useful, but it changes how I read the famine relief figures. Menon’s estimate of 31,000 people on relief works by mid-1955 depends on a monthly series that, as far as I can tell, he reconstructed from the later annual report rather than the monthly returns themselves. That is a reasonable choice and I do not think he hides it, but it smooths over exactly the months where the local correspondence suggests things were worst. In what follows I use his series where the monthly returns are missing and mark those months clearly in Figure 3. Readers who want the conservative reading can simply ignore the shaded columns.`
  };

  loadExample(type: string) {

    this.activeExample = type;
  
    const text = this.exampleTexts[type];
  
    if (this.inputEditor) {
      this.inputEditor.nativeElement.innerText = text;
  
      // Move cursor at the end
      const range = document.createRange();
      const selection = window.getSelection();
  
      range.selectNodeContents(this.inputEditor.nativeElement);
      range.collapse(false);
  
      selection.removeAllRanges();
      selection.addRange(range);
    }
  
    // trigger existing word count / validation logic
    this.onInputEditorChange(text);
  }

  getScoreLabel(score: number): string {
    if (score <= 19) {
      return 'Confident Human';
    } else if (score <= 39) {
      return 'Leaning Human';
    } else if (score <= 59) {
      return 'Inconclusive';
    } else if (score <= 79) {
      return 'Leaning AI';
    } else {
      return 'Confident AI';
    }
  }

  
  checkAnotherText(): void {
    this.aiContentScore = null;
    this.humanContentScore = null;
    this.inputText = '';
    this.inputWordCount = 0;
  
    this.showErrorModal = false;
    this.showLoadingState = false;
    this.isSubmitBtnDisabled = false;
  
    setTimeout(() => {
      const editor = document.getElementById('inputEditor');
  
      if (editor) {
        editor.setAttribute('contenteditable', 'true');
        editor.focus();
      }
    }, 100);
  }
}
